module.exports = __webpack_public_path__ + "static/media/italian.3e747ae9.jpg";